module.exports = __webpack_public_path__ + "img/map_contact.624234b6.svg";